export default (theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
    },
});
